import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const typography = ({
  spacing,
}: InternalThemeConfig): ComponentsOverrides<Theme>["MuiTypography"] => ({
  h1: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(3),
    },
  },
  h2: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(3),
    },
  },
  h3: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(3),
    },
  },
  h4: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(2),
    },
  },
  h5: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(2),
    },
  },
  h6: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(2),
    },
  },
  body1: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(2),
    },
  },
  body2: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(2),
    },
  },
  caption: {
    "&.MuiTypography-gutterBottom": {
      marginBottom: spacing(2),
    },
  },
  gutterBottom: {
    marginBottom: undefined,
  },
  // TODO : dořešit
  // colorTextPrimary: {
  // 	color: "#000",
  // },
  // colorTextSecondary: {
  // 	color: palette.grey25,
  // },
});

export default typography;
